import React from "react";
import { makeStyles } from "@mui/styles";
import { Card, Box, Avatar, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

const RecruiterBox = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const navigate = useNavigate();

  const currentRecruiter = useSelector((state) => state.current_recruiter);
  const currentCompany = currentRecruiter?.company;

  const useStyles = makeStyles(() => ({
    companyCardBox: {
      backgroundColor: "#FFF",
      borderRadius: "12px",
      boxShadow: "none",
      padding: "20px",
      flex: 1,
    },
    avatar: {
      width: 72,
      height: 72,
      backgroundColor: "#9e9e9e",
      borderRadius: "12px",
    },
    buttonsContainer: {
      display: "flex", 
      gap: isDesktop ? 3 : 1, 
      justifyContent: "space-between", 
      width: "100%",
      alignItems: "center",
    },
    disabledButton: {
      borderRadius: "999px !important",
      height: "35px",
      color: `${theme.palette.text.main} !important`, 
      border: `1px solid ${theme.palette.secondary.grey} !important`,
      minWidth: "auto",
      px: isDesktop ? 2 : 1.5,
      fontSize: "14px !important",
      fontWeight: "400 !important",
      fontFamily: "Segoe UI Regular, sans-serif",
    },
    companyButton: {
      height: "35px",
      textTransform: "none",
      padding: "6px 24px !important",
      backgroundColor: "#FFF",
      border: `1px solid ${theme.palette.secondary.grey_strong} !important`,
      fontSize: "14px !important",
      color: `${theme.palette.text.main} !important`,
      fontWeight: "600 !important",
      borderRadius: "999px !important",
      fontFamily: "Segoe UI Semibold, sans-serif",
      "&:hover": {
        backgroundColor: theme.palette.secondary.hover
      }
    },
  }));

  const classes = useStyles();

  const capitalize = (str) => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  return(
    <Card className={classes.companyCardBox}>
      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", gap: isDesktop ? "20px" : 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>        
          <Avatar
            className={classes.avatar}
            alt="Company Logo"
            variant="square"
            src={currentCompany?.logo_url || undefined}
          >
          </Avatar>
                        
          <Box sx={{flex: 1}}>
            <Typography variant="h3" sx={{ fontWeight: 600, fontSize: "20px !important", color: `${theme.palette.text.main} !important`, fontFamily: "Segoe UI Semibold, sans-serif", lineHeight: "26px" }}>
              {currentCompany?.name}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 500, fontSize: "14px !important", color: `${theme.palette.text.main} !important`, fontFamily: "Segoe UI Semibold, sans-serif", lineHeight: 1.2, mt: "8px", mb: isDesktop ? "1px" : 0 }}>
              {capitalize(currentCompany?.company_industry)}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "14px !important", color: `${theme.palette.text.main} !important`, fontFamily: "Segoe UI Semibold, sans-serif", lineHeight: 1.2 }}>
              {capitalize(currentCompany?.city)}
            </Typography>
          </Box>
        </Box>
        <Box className={classes.buttonsContainer} sx={{ "& .MuiButton-root": { textTransform: "none" } }}>
          <Button variant="outlined" disabled className={classes.disabledButton}>
            {currentCompany?.company_page_completion || 0}% {" "}
            <FormattedMessage id="recruiter.completed" />
          </Button>
          <Button variant="rounded" onClick={() => navigate(`/${i18nLocale}/recruiter/settings?selectedSection=company`)} className={classes.companyButton}>
            <FormattedMessage id="settings.cv_complete_cta" />
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default RecruiterBox;